import { FC } from 'react';
import { ListOfAccounts_ExperienceLegacy } from './experience-legacy';
import { ListOfAccounts_ExperienceFunds } from './experience-funds';
import { useExperience } from '~/hooks/use-experience';

export const ListOfAccounts: FC = () => {
  /**
   * Hooks
   */
  const showFundsExperience = useExperience();

  /**
   * DOM
   */
  if (showFundsExperience) {
    return <ListOfAccounts_ExperienceFunds />;
  }

  return <ListOfAccounts_ExperienceLegacy />;
};
